import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { LookupService } from "../../../../shared/services/lookup.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { AutoCompleteComponent, DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { Device } from "../../../../shared/models";
import { DeviceModelsService } from "../../../../shared/services/device-models.service";
import { DeviceModelDto } from "../../../../shared/models/device/device-model-dto";
import { CreateCustomerObjectDeviceDto } from "../../../../shared/models/device/create-customer-object-device.dto";

@Component({
    selector: 'agreement-customer-device',
    templateUrl: './agreement-customer-device.component.html',
    styleUrls: [
        './agreement-customer-device.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class AgreementCustomerDeviceComponent implements OnInit {
    
    @ViewChild("deviceModelsAutoComplete") deviceModelsAutoComplete: AutoCompleteComponent;

    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onContinueEvent: EventEmitter<CreateCustomerObjectDeviceDto> = new EventEmitter<CreateCustomerObjectDeviceDto>();

    device: CreateCustomerObjectDeviceDto;

    deviceTypes: KeyValueObject[] = [];
    fullDeviceModels: DeviceModelDto[] = [];
    deviceModels: KeyValueObject[] = [];
    dropDownDeviceModels: KeyValueObject[] = [];
    requestCategories: KeyValueObject[] = [];

    loading: boolean;

    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    constructor(
        private lookupService: LookupService,
        private deviceModelsService: DeviceModelsService
    ) { }

    ngOnInit(): void {
        this.loading = true;
        this.device = new CreateCustomerObjectDeviceDto;

        const deviceTypes$ = this.lookupService.getData('device-types', null);
        const deviceModels$ = this.deviceModelsService.getAll(true);
        const requestCategories$ = this.lookupService.getData('request-categories', null);

        forkJoin(([deviceTypes$, deviceModels$, requestCategories$])).subscribe(([deviceTypes, deviceModels, requestCategories]) => {
            this.deviceTypes = deviceTypes;
            this.fullDeviceModels = deviceModels.filter(x => x.isCustomerDevice);
            this.deviceModels = this.fullDeviceModels.map(x => new KeyValueObject(x.id, x.name));
            this.requestCategories = requestCategories;
            this.loading = false;
        });
    }
    
    cancel() {
        this.onCancelEvent.emit();
    }

    continue() {
        this.onContinueEvent.emit(this.device);
    }

    filterDeviceModelName(value: string) {
        this.device.deviceModelId = null;
        this.dropDownDeviceModels = value == null || value.trim() == '' 
            ? this.deviceModels
            : this.deviceModels.filter(x => x.name.trim().toLowerCase().includes(value.trim().toLowerCase()));

        if (this.dropDownDeviceModels.length == 0) {
            this.deviceModelsAutoComplete.togglePopup(false);
        }
    }
    
    changeValueDeviceModel(value: string) {
        let selectedModel = this.fullDeviceModels.find(x => x.name == value);
        if (selectedModel != null) {
            this.device.deviceModelId = selectedModel.id;
            this.device.requestCategoryId = selectedModel.requestCategoryId;
        }
    }

    get canSave(): boolean {
        return this.device.deviceTypeId != null && 
            (this.device.deviceModelId != null || this.device.deviceModelName != null) &&
            (this.device.requestCategoryId != null || !this.requestCategoryRequired);
    }

    get requestCategoryRequired(): boolean {
        return this.device.deviceModelId == null && this.device.deviceModelName != null;
    }
}